export default {
    helpInfo: 'errors.helpInfo',
    '403': 'errors.403',
    '404': 'errors.404',
    '500': 'errors.500',
    incorrectData: 'errors.incorrectData',
    orderChangeStatus: 'errors.orderChangeStatus',
    'default': 'errors.default',
    '390': 'errors.failedToUpdateTheStamps',
};